import { useState } from 'react';
import { Modal } from 'antd';

import { UserResourceControllerApiFactory as userAPI } from '../../api_client/parameter_api';
import { SessionModalProps } from './types';
import { apiLocation } from '../../config';
import { insertTokenIntoHttp, setToken } from '../../utils/token';

const SessionModal = ({ modal, ok, cancel }: SessionModalProps) => {
  const [saving, setSaving] = useState<boolean>(false);

  const handleOk = async () => {
    setSaving(true);
    const { data, headers } = await userAPI(undefined, apiLocation).refreshJwt();
    setSaving(false);
    setToken({ token: data, expires: headers.expires });
    insertTokenIntoHttp(data);
    ok();
  };

  return (
    <Modal
      zIndex={1001}
      title='Session expires'
      visible={modal.visible}
      okButtonProps={{ loading: saving }}
      onCancel={cancel}
      onOk={handleOk}
    >
      <div>Your session expires after 3 minutes</div>
      <div>Do you want to stay in this session?</div>
    </Modal>
  );
};

export default SessionModal;
